import { categories, feedItems } from "@/mocks/gossip";

type Props = {
  activeFilter: string;
  onChange: (filter: string) => void;
};

const ALL = "全部";

export default function FeedSection({ activeFilter, onChange }: Props) {
  const filters = [ALL, ...categories.map((cat) => cat.name)];
  const visible = activeFilter === ALL ? feedItems : feedItems.filter((item) => item.category === activeFilter);

  return (
    <section id="feed" className="bg-background-50 py-16 md:py-24">
      <div className="shell">
        <div className="flex flex-col gap-4 border-b border-background-200 pb-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <span className="text-xs font-medium uppercase tracking-[0.2em] text-primary-600">Live Feed</span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">最新爆料</h2>
            <p className="mt-2 text-sm text-foreground-600">
              共 <strong className="font-medium text-foreground-900">{visible.length}</strong> 条内容 · 按发布时间倒序
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            {filters.map((filter) => {
              const isActive = filter === activeFilter;
              return (
                <button
                  key={filter}
                  type="button"
                  onClick={() => onChange(filter)}
                  className={`cursor-pointer whitespace-nowrap rounded-full border px-4 py-2 text-sm transition-colors ${
                    isActive
                      ? "border-primary-500 bg-primary-500 text-background-50"
                      : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                  }`}
                >
                  {filter}
                </button>
              );
            })}
          </div>
        </div>

        {visible.length > 0 ? (
          <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {visible.map((item) => (
              <article
                key={item.id}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="h-44 w-full overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title}相关配图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-sm bg-primary-100 px-1.5 py-0.5 text-[11px] text-primary-700">{item.category}</span>
                    <span className="rounded-sm bg-background-100 px-1.5 py-0.5 text-[11px] text-foreground-600">{item.tag}</span>
                  </div>
                  <h3 className="mt-3 font-heading text-lg leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{item.excerpt}</p>
                  <p className="mt-4 flex items-center justify-between border-t border-background-100 pt-3 text-[11px] text-foreground-500">
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-time-line" aria-hidden="true" />
                      {item.time}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-eye-line" aria-hidden="true" />
                      {item.reads}
                    </span>
                  </p>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="mt-8 flex flex-col items-center rounded-lg border border-dashed border-background-300 bg-background-100/60 py-16 text-center">
            <i className="ri-inbox-archive-line text-4xl text-foreground-400" aria-hidden="true" />
            <p className="mt-3 text-sm text-foreground-600">该分类暂时还没有新料，换个分类看看？</p>
            <button
              type="button"
              onClick={() => onChange(ALL)}
              className="btn-ghost mt-5 cursor-pointer"
            >
              查看全部爆料
            </button>
          </div>
        )}
      </div>
    </section>
  );
}